@use "@/styles/variables/fonts" as *;
@use "@/styles/themes/themes";

.appTitle {
  height: 4em;
  position: relative;

  .image {
    width: 2em;
  }

  .logo {
    &:hover {
      cursor: pointer;
    }
  }

  .text {
    @include themes.theme() {
      color: themes.themeValue(primary);
    }

    text-align: center;
    font-size: $large;
    user-select: none;
  }
}
